/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type ClearEventPlatformIdMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ClearEventPlatformIdMutation = {
  clearEventPlatformId: Pick<Types.User, "id" | "event_platform_user_id">;
};

export const ClearEventPlatformIdDocument = gql`
  mutation ClearEventPlatformId {
    clearEventPlatformId {
      id
      event_platform_user_id
    }
  }
`;

/**
 * __useClearEventPlatformIdMutation__
 *
 * To run a mutation, you first call `useClearEventPlatformIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearEventPlatformIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearEventPlatformIdMutation, { data, loading, error }] = useClearEventPlatformIdMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearEventPlatformIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ClearEventPlatformIdMutation,
    ClearEventPlatformIdMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    ClearEventPlatformIdMutation,
    ClearEventPlatformIdMutationVariables
  >(ClearEventPlatformIdDocument, baseOptions);
}
export type ClearEventPlatformIdMutationHookResult = ReturnType<
  typeof useClearEventPlatformIdMutation
>;
export type ClearEventPlatformIdMutationResult =
  ApolloReactCommon.MutationResult<ClearEventPlatformIdMutation>;
export type ClearEventPlatformIdMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ClearEventPlatformIdMutation,
    ClearEventPlatformIdMutationVariables
  >;
